"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsSlider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const webexUI_1 = require("webexUI");
class TabsSlider extends React.Component {
    constructor(props) {
        super(props);
        this.onWindowResize = (0, webexUI_1.debounce)(this.updateScrollPositionOnResize.bind(this), 200);
        this.marginBetweenTabs = 5;
        this.state = {
            previousTabIndex: null,
            hasLeftArrow: false,
            hasRightArrow: false,
            currentTabWidth: 0,
        };
        this.handleTabWidthChange = () => {
            const { tabsRefs, selectedTabIndex } = this.props;
            const currentTabWidth = tabsRefs[selectedTabIndex].getBoundingClientRect().width;
            if (currentTabWidth !== this.state.currentTabWidth) {
                this.updateScrollPositionOnResize();
                this.setState({
                    currentTabWidth: currentTabWidth,
                });
            }
        };
        this.updateTabsSliderState = () => {
            const { tabsRefs, selectedTabIndex } = this.props;
            const currentTabWidth = tabsRefs[selectedTabIndex].getBoundingClientRect().width;
            this.updateTabsScrollPosition();
            this.setState({
                previousTabIndex: this.props.selectedTabIndex,
                hasLeftArrow: this.shouldShowLeftArrow(),
                hasRightArrow: this.shouldShowRightArrow(),
                currentTabWidth: currentTabWidth,
            });
        };
        this.visibleTab = (visibleSliderAreaLeft, visibleSliderAreaWidth, previousTabWidth, previousTabLeft, currentTabWidth, currentTabLeft) => {
            // current tab is fully visible
            if (currentTabLeft > visibleSliderAreaLeft) {
                // previous tab width + current tab width > visible slider width =>
                // => all current tab is visible (on the end of visible slider) and part of previous
                if (previousTabWidth + currentTabWidth > visibleSliderAreaWidth) {
                    const previousTabNotSuitedWidth = currentTabWidth + previousTabWidth - visibleSliderAreaWidth;
                    this.sliderContentRef.current.scrollLeft -=
                        visibleSliderAreaLeft - previousTabLeft - previousTabNotSuitedWidth;
                    return;
                }
                else {
                    // current tab is fully visible and previous is partially or fully visible
                    // current tab width + previous width < visible slider width =>
                    // => scroll - two tabs should be fully visible
                    this.sliderContentRef.current.scrollLeft -= visibleSliderAreaLeft - previousTabLeft;
                    return;
                }
            }
            else {
                // current tab is not fully visible
                // current tab width > visible slider width => scroll to the beginning of current tab
                if (currentTabWidth > visibleSliderAreaWidth) {
                    this.sliderContentRef.current.scrollLeft -= visibleSliderAreaLeft - currentTabLeft;
                    return;
                }
                else {
                    // current tab is not fully visible
                    // current tab + previous tab width can suit on slider => scroll - two tabs should be visible
                    this.sliderContentRef.current.scrollLeft -=
                        visibleSliderAreaLeft - currentTabLeft + previousTabWidth + this.marginBetweenTabs;
                    return;
                }
            }
        };
        this.updateTabsScrollPosition = () => {
            const { tabsRefs, selectedTabIndex } = this.props;
            const { previousTabIndex } = this.state;
            const currentTab = tabsRefs[selectedTabIndex].getBoundingClientRect();
            const visualSliderArea = this.sliderRef.current.getBoundingClientRect();
            const currentTabRight = currentTab.right;
            const currentTabLeft = currentTab.left;
            const currentTabWidth = currentTab.width;
            const visibleSliderAreaWidth = visualSliderArea.width;
            const visibleSliderAreaRight = visualSliderArea.right;
            const visibleSliderAreaLeft = visualSliderArea.left;
            const sliderContentRight = this.sliderContentRef.current.getBoundingClientRect().right;
            // clicked item is last tab => scroll to the end of content
            if (selectedTabIndex === tabsRefs.length - 1) {
                this.sliderContentRef.current.scrollLeft = sliderContentRight;
                return;
            }
            // clicked item is first tab => scroll to the begin
            if (selectedTabIndex === 0) {
                this.sliderContentRef.current.scrollLeft = 0;
                return;
            }
            //scroll to right side
            if (selectedTabIndex > previousTabIndex) {
                const nextTab = tabsRefs[selectedTabIndex + 1].getBoundingClientRect();
                const nextTabRight = nextTab.right;
                const nextTabWidth = nextTab.width;
                // current tab width > visible slider width => scroll to the begin of current tab
                // next tab width + current tab width > visible slider width =>
                // => scroll - current tab should be on the beginning of slider, the rest width contains part of next tab
                if (currentTabWidth + nextTabWidth > visibleSliderAreaWidth) {
                    const nextTabNotSuitedWidth = currentTabWidth + nextTabWidth - visibleSliderAreaWidth;
                    this.sliderContentRef.current.scrollLeft +=
                        nextTabRight - visibleSliderAreaRight - nextTabNotSuitedWidth;
                    return;
                }
                // current tab is visible fully
                if (currentTabRight < visibleSliderAreaRight) {
                    // next tab is partially visible => scroll - current tab and next tab should be fully visible
                    if (nextTabRight > visibleSliderAreaRight) {
                        this.sliderContentRef.current.scrollLeft += nextTabRight - visibleSliderAreaRight;
                    }
                    // next tab is fully visible => there is no need to scroll
                    return;
                }
                else {
                    // current tab is visible partially => scroll - current tab and next tab should be fully visible
                    this.sliderContentRef.current.scrollLeft +=
                        currentTabRight - visibleSliderAreaRight + nextTabWidth + this.marginBetweenTabs;
                    return;
                }
            }
            else {
                const previousTab = tabsRefs[selectedTabIndex - 1].getBoundingClientRect();
                const previousTabLeft = previousTab.left;
                const previousTabWidth = previousTab.width;
                // scroll to left side
                // previous tab width + current tab width > visible slider width =>
                // => all current tab is visible (on the end of visible slider) and part of previous
                if (currentTabWidth < visibleSliderAreaWidth &&
                    previousTabWidth + currentTabWidth > visibleSliderAreaWidth) {
                    const previousTabNotSuitedWidth = currentTabWidth + previousTabWidth - visibleSliderAreaWidth;
                    this.sliderContentRef.current.scrollLeft -=
                        visibleSliderAreaLeft - previousTabLeft - previousTabNotSuitedWidth;
                    return;
                }
                this.visibleTab(visibleSliderAreaLeft, visibleSliderAreaWidth, previousTabWidth, previousTabLeft, currentTabWidth, currentTabLeft);
            }
        };
        this.handleScrollSlider = () => {
            if (this.shouldShowLeftArrow()) {
                this.setState({
                    hasLeftArrow: true,
                });
            }
            if (!this.shouldShowLeftArrow()) {
                this.setState({
                    hasLeftArrow: false,
                });
            }
            if (this.shouldShowRightArrow()) {
                this.setState({
                    hasRightArrow: true,
                });
            }
            if (!this.shouldShowRightArrow()) {
                this.setState({
                    hasRightArrow: false,
                });
            }
        };
        this.shouldShowLeftArrow = () => {
            if (this.sliderContentRef.current) {
                return this.sliderContentRef.current.scrollLeft !== 0;
            }
        };
        this.shouldShowRightArrow = () => {
            if (this.sliderContentRef.current && this.sliderRef.current) {
                const { tabsRefs } = this.props;
                const sliderContentRight = this.sliderContentRef.current.getBoundingClientRect().right;
                const lastTabRight = tabsRefs[tabsRefs.length - 1].getBoundingClientRect().right;
                return lastTabRight - 1 > sliderContentRight;
            }
        };
        this.handleLeftClicked = () => {
            this.sliderContentRef.current.scrollLeft = 0;
            this.setState({
                hasLeftArrow: false,
                hasRightArrow: true,
            });
        };
        this.handleRightClicked = () => {
            const { tabsRefs } = this.props;
            this.sliderContentRef.current.scrollLeft =
                tabsRefs[tabsRefs.length - 1].getBoundingClientRect().right;
            this.setState({
                hasLeftArrow: true,
                hasRightArrow: false,
            });
        };
        this.sliderRef = React.createRef();
        this.sliderContentRef = React.createRef();
    }
    componentDidMount() {
        this.updateTabsSliderState();
        window.addEventListener('resize', this.onWindowResize);
    }
    componentDidUpdate() {
        if (this.state.previousTabIndex !== this.props.selectedTabIndex) {
            this.updateTabsSliderState();
        }
        else {
            this.handleTabWidthChange();
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
    }
    render() {
        const { hasLeftArrow, hasRightArrow } = this.state;
        return ((0, jsx_runtime_1.jsx)("div", { className: "tabs-slider border-primary flex justify-center border-b mb-15", ref: this.sliderRef, children: (0, jsx_runtime_1.jsxs)("div", { className: "container-px relative overflow-hidden", children: [hasLeftArrow ? ((0, jsx_runtime_1.jsx)("div", { className: "p-2xs absolute top-0 left-0 inline-flex h-full w-[100px] items-center justify-start bg-linear-to-r from-white via-white via-[60px]", children: (0, jsx_runtime_1.jsx)("button", { className: "tabs-slider__arrow tabs-slider__arrow--previous bg-fill-secondary hover:bg-fill-secondary-hovered active:bg-fill-secondary-pressed h-11 w-11 rounded-full", onClick: this.handleLeftClicked, children: (0, jsx_runtime_1.jsx)("div", { className: "relative h-6 w-6 overflow-hidden", children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "chevron-left" }) }) }) })) : null, (0, jsx_runtime_1.jsx)("div", { ref: this.sliderContentRef, onScroll: this.handleScrollSlider, className: "overflow-x-auto overflow-y-hidden scrollbar-hidden\r\n             [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden", tabIndex: -1, children: (0, jsx_runtime_1.jsx)("ul", { className: "tabs-slider__content full-height subtitle-lg-strong flex whitespace-nowrap", children: this.props.children }) }), hasRightArrow ? ((0, jsx_runtime_1.jsx)("div", { className: " p-2xs absolute top-0 right-0 inline-flex h-full w-[100px] items-center justify-end bg-linear-to-l from-white via-white via-[60px]", children: (0, jsx_runtime_1.jsx)("button", { className: "tabs-slider__arrow tabs-slider__arrow--next bg-fill-secondary hover:bg-fill-secondary-hovered active:bg-fill-secondary-pressed h-11 w-11 rounded-full", onClick: this.handleRightClicked, children: (0, jsx_runtime_1.jsx)("div", { className: "relative h-6 w-6 overflow-hidden", children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "chevron-right" }) }) }) })) : null] }) }));
    }
    updateScrollPositionOnResize() {
        var _a, _b;
        const { tabsRefs, selectedTabIndex } = this.props;
        const currentTabRight = (_a = tabsRefs[selectedTabIndex]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().right;
        const visibleSliderAreaRight = (_b = this.sliderContentRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().right;
        if (currentTabRight - 1 > visibleSliderAreaRight) {
            this.sliderContentRef.current.scrollLeft += currentTabRight - visibleSliderAreaRight;
        }
        this.setState({
            hasLeftArrow: this.shouldShowLeftArrow(),
            hasRightArrow: this.shouldShowRightArrow(),
        });
    }
}
exports.TabsSlider = TabsSlider;
